export default __webpack_public_path__ + "static/media/medicine.020ced4e.png";